import { Global } from "@emotion/react";
import { css } from "@emotion/react";
import { selectedClassesWidths } from "./elements/ProductSelectionDropdown";
import { CSS_MQ } from "../../styles/breakpoints";

export const gridStyles = css`
  display: grid;

  ${CSS_MQ.atLeastMd} {
    margin-left: auto;
    margin-right: auto;
  }

  &.selected-1 {
    grid-template-columns: repeat(1, 1fr);
  }

  &.selected-2 {
    grid-template-columns: repeat(2, 1fr);
  }

  &.selected-3 {
    grid-template-columns: repeat(3, 1fr);
  }

  ${selectedClassesWidths}

  grid-column-gap: 10px;
  ${CSS_MQ.atLeastMd} {
    grid-column-gap: 20px;
  }
`;
